import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=54cdb0b4&scoped=true&"
import script from "./Render.vue?vue&type=script&lang=js&"
export * from "./Render.vue?vue&type=script&lang=js&"
import style0 from "./Render.vue?vue&type=style&index=0&id=54cdb0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cdb0b4",
  null
  
)

export default component.exports